function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
export var LATEST_AFFINITY_KEY = Symbol("LATEST_AFFINITY");
export var SEEN_AFFINITIES = Symbol("SEEN_AFFINITIES");
var n = 10;
/**
 * Returns the top n affinities after incrementing the affinities passed in and decrementing the rest
 * @param {Object.<string, number>} counts
 * @param {string or array} affinities
 * @returns {Object.<string, number>} a new counts object with the top n affinities
 */ export var incrementAffinities = function(counts, affinities) {
    var batch = affinities;
    if (typeof batch === "string") {
        batch = new Array(affinities);
    }
    var lastAffinity = counts[LATEST_AFFINITY_KEY];
    var seenAffinities = counts[SEEN_AFFINITIES] || new Set(); // all affinities seen this session so far
    var entries = Object.entries(counts);
    // Add affinities that don't yet exist
    batch.forEach(function(affinity) {
        if (!Object.prototype.hasOwnProperty.call(counts, affinity)) {
            entries.push([
                affinity,
                0
            ]);
        }
    });
    // calculate new scores for each entry
    entries = entries.map(function(entry) {
        var _entry = _sliced_to_array(entry, 2), affinity = _entry[0], value = _entry[1];
        var incrementBy = 0;
        if (batch.includes(entry[0])) {
            if (lastAffinity) {
                incrementBy = n;
            } else {
                // new session
                incrementBy = n * 2;
            }
        } else {
            incrementBy = -1;
        }
        return [
            affinity,
            value + incrementBy
        ];
    });
    // limit number of affinities to n
    entries = entries.sort(function(a, b) {
        return b[1] - a[1];
    }); // sort in descending order
    var index = entries.length - 1;
    // remove affinities that were not part of the batch
    // in ascending order until we have at most n entries
    // or we've reached the start of the array
    while(entries.length > n && index > -1){
        var _entries_index = _sliced_to_array(entries[index], 1), key = _entries_index[0];
        if (!batch.includes(key)) {
            entries.splice(index, 1);
        }
        index -= 1;
    }
    // in case there were more than n affinities to increment
    // only keep first n
    entries.slice(0, n);
    // affinities should have a value of atleast zero
    entries = entries.map(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            Math.max(0, value)
        ];
    });
    // construct a new object from our top n affinities
    var newCounts = entries.reduce(function(acc, param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        acc[key] = value;
        return acc;
    }, {});
    // Using a Symbol to store the last affinity incremented, since symbols are not iterable, or serialized
    // And require access to the symbol to get the value, it can't accidentally be used somewhere
    batch.forEach(function(affinity) {
        seenAffinities.add(affinity);
    });
    newCounts[SEEN_AFFINITIES] = seenAffinities;
    newCounts[LATEST_AFFINITY_KEY] = batch[batch.length - 1];
    return newCounts;
};
